import { isEmpty } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { DropdownEDGE, DropdownEDGEyear, EDGEChart, ModalFeedbackSummary } from '..';
import arrowRight from '../../assets/img/arrowRight.svg';
import pen from '../../assets/img/vector.svg';
import { EDGE_OPTION_LABEL, EDGE_OPTION_VALUE, PERMISSION } from '../../utils/constants';
import styles from './edge-view.module.scss';
import { TP_PRINT_SECTION_NAME } from '../TalentProfilePrintPreview/constants';
import { useSelector } from 'react-redux';
import { get5LatestYear } from '../../utils/helper';
import ModalEditVerbatimFeedback from '../ModalEditVerbatimFeedback/ModalEditVerbatimFeedback';

const EDGEView = ({ id, roleUser, isPrintTP, tokenTalentProfile, isDownloadPreview }) => {
  const [selectedYear, setSelectedYear] = useState('All');
  const [fullOptionYears, setFulloptionYears] = useState([]);
  const [optionYearsAfterChosen, setOptionYearsAfterChosen] = useState([]);
  const [listSelectType, setListSelectType] = useState([]);
  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDisableYearAllOption, setIsDisableYearAllOption] = useState(false);
  const [isYearsDisabled, setIsYearsDisabled] = useState(false);
  const [isAllBtnDisabled, setIsAllBtnDisabled] = useState(false);
  const handleShow = () => setShow(true);
  const { permissions } = roleUser;
  const { year, category } = useSelector((state) =>
    isDownloadPreview
      ? state.app.talentProfile.downloadProfile.downloadSettings.radioOptions
      : state.app.talentProfile.printProfile.printSettings.radioOptions,
  );

  const isHasEditPermission = useMemo(() => {
    if (isEmpty(permissions)) return false;
    return permissions.includes(PERMISSION.TP_EDIT_VERBATIM_FEEDBACK_TAGGING);
  }, [permissions]);

  const optionYear = () => {
    let listOptionYear = get5LatestYear();
    listOptionYear.unshift('All');
    return listOptionYear;
  };

  useEffect(() => {
    let fullyear = [...fullOptionYears];
    setOptionYearsAfterChosen(fullyear);
  }, [selectedYear, fullOptionYears]);

  useEffect(() => {
    setFulloptionYears(optionYear());
  }, []);

  useEffect(() => {
    if (!isPrintTP) return;
    setSelectedYear(year);
    if (category === 'all_chart') {
      setListSelectType([
        {
          label: EDGE_OPTION_LABEL.SMA,
          value: EDGE_OPTION_VALUE.SMA,
        },
        {
          label: EDGE_OPTION_LABEL.EXTERNAL,
          value: EDGE_OPTION_VALUE.EXTERNAL,
        },
        {
          label: EDGE_OPTION_LABEL.MODEL,
          value: EDGE_OPTION_VALUE.MODEL,
        },
      ]);
      return;
    }
    setListSelectType([{ value: category, label: category }]);
  }, [year, category, isPrintTP]);

  const handleShowEdit = () => setShowEdit(true);

  const onChangeSelectedYear = (value, allChart) => {
    let year = 'All';
    let disableAllOption = isDisableYearAllOption;
    let yearsDisabled = isYearsDisabled;
    if (allChart !== 3) {
      switch (value) {
        case EDGE_OPTION_LABEL.EXTERNAL:
        case EDGE_OPTION_LABEL.SMA:
          disableAllOption = false;
          yearsDisabled = false;
          break;
        case EDGE_OPTION_LABEL.MODEL:
          yearsDisabled = true;
          disableAllOption = false;
          break;
        default:
          yearsDisabled = false;
          disableAllOption = false;
          break;
      }
      setSelectedYear(year);
      setIsDisableYearAllOption(disableAllOption);
      setIsYearsDisabled(yearsDisabled);
    } else {
      setSelectedYear(year);
    }
  };

  return (
    <>
      <div className={styles.edge} data-testid="edge" data-print-section={TP_PRINT_SECTION_NAME.LEADERSHIP_COMPETENCIES}>
        <div className={styles.edge__header}>
          <h3 className={styles.edge__h3}>EDGE</h3>
          {!isPrintTP && (
            <div className={styles.edge__filter}>
              <DropdownEDGE
                listSelectType={listSelectType}
                setListSelectType={setListSelectType}
                onChangeSelectedYear={onChangeSelectedYear}
                setIsAllBtnDisabled={setIsAllBtnDisabled}
              />
              <div className={styles.edge__dropcs}>
                <DropdownEDGEyear
                  options={optionYearsAfterChosen || []}
                  setSelected={setSelectedYear}
                  selected={selectedYear}
                  isDisableYearAllOption={isDisableYearAllOption}
                  isYearsDisabled={isYearsDisabled}
                  isAllBtnDisabled={isAllBtnDisabled}
                />
              </div>
            </div>
          )}
        </div>
        <div className={styles.edge__chart}>
          <EDGEChart
            selectedYear={selectedYear}
            listSelectType={listSelectType}
            id={id}
            roleUser={roleUser}
            tokenTalentProfile={tokenTalentProfile}
          />
        </div>
        {!isPrintTP && (
          <div className={styles.feedback__viewMore}>
            <div onKeyDown={() => {}} onClick={handleShow} className={styles.feedback__viewMoreText}>
              <p> View feedback</p>
              <img src={arrowRight} alt="" className={styles.feedback__arrowRight} />
            </div>
            {isHasEditPermission && (
              <img src={pen} alt="pen" style={{ cursor: 'pointer' }} onKeyDown={() => {}} onClick={handleShowEdit} className={styles.feedback__pen} />
            )}
          </div>
        )}
      </div>
      {showEdit && (
        <ModalEditVerbatimFeedback show={showEdit} setShow={setShowEdit} roleUser={roleUser} id={id} tokenTalentProfile={tokenTalentProfile} />
      )}
      {show && <ModalFeedbackSummary show={show} setShow={setShow} roleUser={roleUser} id={id} tokenTalentProfile={tokenTalentProfile} />}
    </>
  );
};
export default EDGEView;
